module.exports = __webpack_public_path__ + "static/maple-03ccd20eb5422d946e2eb0be3e521d8a.svg";